var animation = {"enter":"Animation_enter__iHD6F","enterActive":"Animation_enterActive__17iPW","exit":"Animation_exit__3qPEy","exitActive":"Animation_exitActive__2WFSY"};

export default animation;
